import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-adminsales-changeservice',
  templateUrl: './adminsales-changeservice.component.html',
  styleUrls: ['./adminsales.component.css']
})
export class AdminsalesChangeserviceComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
  private route: ActivatedRoute,
  public LoadJsOrder: LoadJsService,
    private router: Router, 
  ) { }
  
  formIdProduct = this.fb.group({
    productsource : [''],
  });
  formChange = this.fb.group({
    productid : [''],
    quota : [''],
    existquota : [''],
    producttype : [''],
  });
  formPush = this.fb.group({
    partnerid : [''],
    productid : [''],
    totalquota : [''],
    newvalue : [''],
    producttype : [''],
  });
  formOrderstb = this.fb.group({
    partnerid: [''],
    noorder: [''],
    nogrf: [''],
    noiom: [''],
    sales_name: [''],
    quota: [''],
    orderdate: [''],
    product: ['']
  })
  formProduct = this.fb.group({
    productid : [''],
    transactiontype: [''],
    note: [''],
    quota: ['']
  });

  btn_save = true
  btn_loading = false
  alert_failed = false
  alert_success = false
  alert_redirect = false
  alert_quota = false
  table_product_kosong = true
  table_product_data = false
  
  selectedProduct: any = []
  data_table_product: any = []
  data_productsource:any={}
  data_partner:any={}
  data_product:any={}
  response_api:any={}
  Servicedetail:any={}
  Servicedetail2:any={}
  Servicelist:any={}

  serviceValue=''
  confirmation=false
  confirmation0=false
  confirmation1=false
  confirmation01=false
  showinput=false

  count:number = 0
  sum:number = 0

  ngOnInit() {
    // this.sourceProduct()
    // this.partner()
    this.LoadJsOrder.loadScriptOrderService()
    this.checkquota()
    this.loadStart()
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        // console.log(params); // {order: "popular"}
        // this.loadServiceQuota(id);
        this.loadServicedetail(id);

      });
  }

  loadServicedetail(id: any) {
    // let data = {
    //   "partnerid": item.partnerid,
    //   "productid": item.productid
    // };

    console.log(id);
    return this.partnerService.GetServicedetail(id).subscribe((output: any) => {
      this.Servicedetail = output.data;
      console.log(this.Servicedetail);

      this.loadServicelist();
    })
  }

  loadServicelist() {

    const data = 
    
    {
      "partnerid" : this.Servicedetail.partnerid,
      "productid" : this.Servicedetail.productid,
      "producttype" : this.Servicedetail.producttype,
    }

    console.log(data);
    return this.partnerService.GetServicelistall(data).subscribe((output: any) => {
      this.Servicelist = output.data;
      console.log(this.Servicelist);

      // this.formChange.get('existquota').setValue(this.Servicelist.totalquota)

    })
  }

  quota() {
    if (this.serviceValue) {

      
      // const servid = this.Servicedetail.id
      console.log("ada", this.serviceValue)

      return this.partnerService.GetServicedetail(this.serviceValue).subscribe((output: any) => {
        this.Servicedetail2 = output.data;
        console.log(this.Servicedetail2);
  
        this.formChange.get('existquota').setValue(this.Servicedetail.totalquota);
      })
    }
    
    else{
       console.log("kosong")
       this.formChange.get('existquota').setValue('');

    }
  }

  checkquota() {
    
    if (this.formChange.value.quota == 0 || this.formChange.value.quota == null){
      // console.log("keren", this.formChange.value.existquota, this.formChange.value.quota)
      this.confirmation0=true
      this.confirmation=false

    }else if (this.formChange.value.quota > this.formChange.value.existquota){
      // console.log("keren", this.formChange.value.existquota, this.formChange.value.quota)
      this.confirmation=true
      this.confirmation0=false

    }else{
      // console.log("jelek")
      this.confirmation=false
      this.confirmation0=false
    }
  }

  checkquota1(item:any) {
    
    if (item.quota == 0 || item.quota == null){
      console.log("keren", item)
      this.confirmation01=true
      this.confirmation1=false

    }else if (item.quota > item.existquota){
      console.log("keren2", item)
      this.confirmation1=true
      this.confirmation01=false

    }else{
      console.log("jelek", item)
      this.confirmation1=false
      this.confirmation01=false
    }
  }

  refreshPage() {
    //this.LoadJsOrder.loadScriptOrderService()
    this.sourceProduct()
    this.partner()
  }

  sourceProduct() {
    this.restApi.GetProductsource().subscribe((data: any) => { 
      this.data_productsource = data
      // console.log(this.data_productsource)
    });  
  }
  partner() {
    this.restApi.GetPartner().subscribe((data: {}) => { 
      this.data_partner = data
      // console.log(this.data_order_stb)
    });  
  }
  add() {
    this.showinput=true
    console.log("masuk")
  }
  push() {
    this.data_table_product.forEach(element => {
      this.count = this.count + parseInt(element.quota)
      console.log(element)
    })
    
    this.sum = this.count + this.formChange.get('quota').value
    console.log(this.sum, this.formChange.get('quota').value)

    if (this.sum <= this.Servicedetail.totalquota) { //jika data cocok

      let productid = this.formChange.get('productid').value;
      let product:any = {}
      this.Servicelist.forEach((element:any) => {
        if (element.id == productid) {
          product = element
        }
      });
      // this.formChange.get('productid').setValue(product[0]);
      this.data_table_product.push(
        {
          'productid':this.formChange.get('productid').value, //dari array product list
          'partnerid':this.Servicedetail.partnerid, //dari master, get partnerid
          'productname':product.productname,
          'quota':this.formChange.get('quota').value,
          'existquota':this.Servicedetail.totalquota,
          'producttype':product.producttype,
        }
      )
      console.log(product, this.data_table_product)
      this.resetFormchange()
      this.checkquota()

    }else if (this.sum > this.Servicedetail.totalquota) { //jika lebih
      console.log('lebih')  
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_quota = true
      setTimeout(()=>{
        this.alert_quota = false
        this.count = 0
        this.sum = 0

      }, 3000);

    }else{ //jika gagal
      console.log('gagal')
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_failed = true
      setTimeout(()=>{
        this.alert_failed = false
      }, 6000);
    }

    // console.log(this.count, 'total asli->', this.Servicedetail.totalquota)
  }
  remove(item:any) {
    this.data_table_product.splice(item, 1);
  }

  submitsave(el:HTMLElement) {
    this.data_table_product.forEach(element => {
      this.count = this.count + parseInt(element.quota)
      console.log(element)
    })
    console.log(this.count, 'total asli->', this.Servicedetail.totalquota)
    
    if (this.count == 0 || this.count == null){ //jika kosong
    console.log('ulangin', this.count)

    }else if (this.count <= this.Servicedetail.totalquota) { //jika data cocok

      this.formPush.get('partnerid').setValue(this.Servicedetail.partnerid)
      this.formPush.get('productid').setValue(this.Servicedetail.productid)
      this.formPush.get('totalquota').setValue(this.Servicedetail.totalquota)
      this.formPush.get('producttype').setValue(this.Servicedetail.producttype)
      this.formPush.get('newvalue').setValue(this.data_table_product)

      this.restApi.ChangePartnerService(this.formPush.value)
        .subscribe((data: any) => { 
          this.response_api = data
          console.log(data)
          if (this.response_api.status == true) {
            this.resetTbl()
            console.log('masuk', this.response_api)
  
            this.LoadJsOrder.loadScriptProductStb()
            this.alert_success = true
            setTimeout(()=>{
              el.scrollIntoView({behavior:"smooth"})
            }, 500);
    
            this.alert_redirect = true
            setTimeout(()=>{
              this.redirectListorder("adminsales/servicequota/"+this.Servicedetail.partnerid);
            }, 6000);
          } else {
            console.log('gagal', this.response_api)

            // this.LoadJsOrder.loadScriptProductStb()
            // this.alert_failed = true
          }
        });
      console.log('masuk tp dibawah', this.formPush.value)

    }else if (this.count > this.Servicedetail.totalquota) { //jika lebih
      console.log('lebih')  
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_quota = true
      setTimeout(()=>{
        this.alert_quota = false
      }, 6000);

    }else{ //jika gagal
      console.log('gagal')
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_failed = true
      setTimeout(()=>{
        this.alert_failed = false
      }, 6000);
    }
  }

  getIdProduct(e) {
    this.selectedProduct = []
    this.data_table_product = []
    this.formIdProduct.get('productsource').setValue(e.target.value);
    this.restApi.PostListProduct(this.formIdProduct.value).subscribe((data: {}) => { 
        this.data_product = data
        // console.log(this.data_product)
        for (let i = 0; i < this.data_product.data.length; i++) {
          // console.log(this.data_product.data[i].id);
          this.selectedProduct.push(
            {
              'id':this.data_product.data[i].id+'|'+this.data_product.data[i].productname,
              'name':this.data_product.data[i].productname
            }
          )
        }
        // console.log(this.selectedProduct)
      });  
  }
  resetForm(){
    this.formProduct.reset()
  }
  resetFormchange(){
    this.formChange.reset()
  }
  resetTbl(){
    this.data_table_product = []

  }
  redirectListorder(params: any) {
    this.router.navigate([params]);
  }

  submitProduct() {
    // console.log(this.formProduct.get('productid').value)
    let id = this.formProduct.get('productid').value.split('|');
    this.formProduct.get('productid').setValue(id[0]);
    this.data_table_product.push(
      {
        'product':id[1],
        'productid':id[0],
        'transactiontype':1,
        'quota':this.formProduct.get('quota').value,
        'note':this.formProduct.get('note').value
      }
    )
    // console.log(this.data_table_product)
    // console.log(this.formProduct.value)
  }
  submitOrderService(el: HTMLElement) {
    // let date = this.formOrderstb.get('orderdate').value
    // let orderdate = date.year+'-'+date.month+'-'+date.day
    // this.formOrderstb.get('orderdate').setValue(orderdate)
    this.formOrderstb.get('product').setValue(this.data_table_product)
    let count:number = 0
    this.data_table_product.forEach(element => {
      count = count + parseInt(element.quota)
      console.log(element)
    })
    console.log(count, this.formOrderstb.value.quota)
      if (count == this.formOrderstb.value.quota){
        // console.log("pas")
        this.restApi.PostCreateOrderstb(this.formOrderstb.value)
          .subscribe((data: any) => { 
            this.response_api = data
            console.log(data)
            if (this.response_api.status == true) {
    
              this.LoadJsOrder.loadScriptProductStb()
              this.alert_success = true
              setTimeout(()=>{
                el.scrollIntoView({behavior:"smooth"})
              }, 500);
      
              this.alert_redirect = true
              setTimeout(()=>{
                this.redirectListorder("adminsales/listorder");
              }, 5000);
            } else {

              this.LoadJsOrder.loadScriptProductStb()
              this.alert_failed = true
              // this.loading_create = false
            }
          }
        );
      }else{
        // console.log("jumlah quota stb harus sama dengan jumlah quota service")
        setTimeout(()=>{
          el.scrollIntoView({behavior:"smooth"})
        }, 500);
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_quota = true
        setTimeout(()=>{
          this.alert_quota = false
        }, 6000);
      }
  }
}
